import React from 'react';
import { Outlet } from 'react-router-dom';
import { CredentialVaultCryptoProvider } from './VaultCryptoProvider';

export default function CredentialVaultGate() {
  return (
    <CredentialVaultCryptoProvider>
      <Outlet />
    </CredentialVaultCryptoProvider>
  );
}
